import styled from "styled-components";

export const CenterLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VerticalLine = styled.div`
  display: flex;
  background-color: #dee2e6;
  width: 90%;
  height: 1px;
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding: 100px;

  @media screen and (max-width: 991px) {
    padding-right: 40px;
    padding-left: 40px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #adb5bd;
`;

export const Yazdun = styled.h3`
  font-size: 28px;
  font-weight: 500;
`;

export const Copyright = styled.h4`
  font-size: 20px;
  font-weight: 400;
  padding: 10px;
`;
